import type { MedpraxPageResult } from '../external-integrations';
import type { Specialty } from './schema';

export const mapMedpraxSpecialtyToSpecialty = (
  specialty: MedpraxPageResult,
): Specialty => {
  return {
    code: specialty.Code,
    name: specialty.Description,
  };
};
